<template>
  <i-bxs-right-arrow-circle />
</template>
